module.exports = __webpack_public_path__ + "static/media/carta_69.34f419c7.jpg";